import { call, put, takeLatest } from "redux-saga/effects";
import { Action } from "../../../actions/actions";
import { API } from "../../../api/api";
import { ConfigurationsActionTypes } from "../actions/actionTypes";
import { configurationsAPI } from "../api/api";

function* getMegapotServerList(action: Action) {
    try {
        const response = yield call(() =>
            configurationsAPI.getMegapotServerList(action.payload.provider,action.payload.subsidiary)
        );

        yield put({
            type: ConfigurationsActionTypes.GET_MEGAPOT_SERVER_LIST_SUCCESS,
            payload: response.data
        });
    } catch (e) {
        API.handleError(e.response, "Error getting megapot server list.");

        yield put({
            type: ConfigurationsActionTypes.GET_MEGAPOT_SERVER_LIST_FAIL,
            payload: e
        });
    }
}

export function* getMegapotServerListWatcher() {
    yield takeLatest(ConfigurationsActionTypes.GET_MEGAPOT_SERVER_LIST, getMegapotServerList);
}
